module.exports = __webpack_public_path__ + "static/media/logoCastellonPlaza.609e2991.webp";